import { resolveOrgStatusBucket, orgStatusLabel } from '../../../domain/superadmin/orgStatus';
import type { AdminOrganizationRow } from '../../../domain/superadmin/types';
import { cn } from '@/lib/utils';

type StatusRow = Pick<AdminOrganizationRow, 'subscriptionStatus' | 'blockedAt' | 'trialEndsAt'>;

const BUCKET_STYLES = {
    active: 'border-success/30 bg-success-bg text-success-text',
    trial: 'border-primary/30 bg-primary-subtle text-primary',
    past_due: 'border-warning/30 bg-warning-bg text-warning-text',
    blocked: 'border-error/40 bg-danger-bg text-danger-text',
    canceled: 'border-border bg-surface-subtle text-muted',
    other: 'border-border bg-surface-subtle text-secondary',
} as const;

export function OrganizationStatusBadge({ row }: { row: StatusRow }) {
    const bucket = resolveOrgStatusBucket({
        subscriptionStatus: row.subscriptionStatus,
        blockedAt: row.blockedAt,
        trialEndsAt: row.trialEndsAt,
    });

    return (
        <span
            className={cn(
                'inline-flex rounded-full border px-2 py-0.5 text-[11px] font-medium',
                BUCKET_STYLES[bucket],
            )}
        >
            {orgStatusLabel(bucket)}
        </span>
    );
}
